<template>
  <div class="task-center" :style="{background: isHidden == 1 ? '#24252A' : '#fff'}" v-my-loading="loading">
    <div class="no-task flex column" v-if="isHidden == 2 || isHidden == 0">
      <!--當前沒有任務-->
      <van-empty class="custom-image" :description="$t('300114')">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-jilu1"></use>
        </svg>
      </van-empty>
      <!--更多任务敬请期待-->
      <p>{{ $t('300115') }}</p>
    </div>
    <div v-if="isHidden == 1" class="task-center-banner" :style="{backgroundImage:'url(' + bannerUrl + ')'}">
      <h1>{{ $t('310001') }}</h1>
      <p style="margin-bottom:2rem">{{ $t('300110') }}</p>
      <!-- <div>
        <a class="inline-block" :class="isDirection ? 'rtl' : 'ltr'" href="https://bit.ly/3LlvE5C"><i class="iconfont icon-lianjie"></i>{{ $t('300123') }}</a>
        <a class="inline-block" :class="isDirection ? 'rtl' : 'ltr'" href="https://bit.ly/3MrZ0AR"><i class="iconfont icon-lianjie"></i>BP</a>
      </div> -->
    </div>
    <div v-if="isHidden == 1" class="task-container">
      <ul class="tabs flex-center">
        <li class="tab-item bold pointer active" @click="changeTab('task')">{{ $t('310001') }}</li>
        <li class="tab-item bold pointer" @click="changeTab('rule')">{{ $t('310000') }}</li>
      </ul>
      <div id="task">
        <div class="title">
          <div class="flex-center">
            <svg slot="image" class="icon" aria-hidden="true">
              <use xlink:href="#icon-renwuzhongxin"></use>
            </svg>
            <!--任务中心 310001-->
            <h1 class="bold">{{ $t('310001') }}</h1>
          </div>
          <!--完成任务赢奖励-->
          <!-- <span class="block">{{ $t('300072') }}</span> -->
        </div>
        <ul class="task-list">
          <li class="task-list-item flex-between" v-for="item in taskList" :key="item.id">
            <div class="left-content" :class="isDirection ? 'left-content-rtl' : 'left-content-ltr'">
              <p class="bold">{{ $t(item.title) }}</p>
              <div class="flex-center">
                <svg slot="image" class="icon" aria-hidden="true">
                  <use xlink:href="#icon-a-Group38695"></use>
                </svg>
                <span class="bold inline-block uppercase">+ {{ item.amount }} {{ item.currency }}</span>
                <a :href="item.linkList[language]"
                   v-if="item.type == '3' || item.type == '4' || item.type == '5' || item.type == '6'"><i
                  class="iconfont icon-tishi"></i></a>
              </div>
            </div>
            <div class="right-button flex column">
              <van-button class="first-btn" v-show="item.type == '3' || item.type == '4' || item.type == '5'"
                          @click="handleButton(item)">
                {{ item.type | buttonFilter($i18n) }}
                <van-icon :name="isDirection ? 'arrow-left' : 'arrow'"/>
              </van-button>
              <van-button class="form-btn" v-show="!item.completed && item.type != '7' && item.type != '8'"
                          @click="handleClick(item)">
                {{ item.type | buttonFilter2($i18n) }}
              </van-button>
              <!--已完成-->
              <van-button class="completed-btn" v-show="item.completed && item.type != 9" disabled>
                {{ $t('300109') }}
              </van-button>
              <!--已失效-->
              <van-button class="completed-btn" v-show="item.completed && item.type == 9" disabled>
                {{ item.completed == 2 ? $t('300122') : $t('300109') }}
              </van-button>
              <p class="flex column" v-show="item.type == '7' || item.type == '8'">
                <!--已领取（次）-->
                <span class="block">{{ $t('300105') }}</span>
                <span class="block bold">{{ isLogin ? item.completedNumber : 0 }}</span>
              </p>
            </div>
          </li>
        </ul>
        <!-- <span class="block tip-message">*{{ $t('300075') }}</span> -->
        <span class="block completed" v-show="isLogin && userInfo.isWhitelist">{{ $t('300091') }}</span>
      </div>
      <div id="rule">
        <div class="title">
          <div class="flex-center">
            <svg slot="image" class="icon" aria-hidden="true">
              <use xlink:href="#icon-jiesuorenwu"></use>
            </svg>
            <!--解锁规则-->
            <h1 class="bold">{{ $t('310000') }}</h1>
          </div>
          <!--完成交易，解锁ET-->
          <!-- <span class="block">{{ $t('300074') }}</span> -->
        </div>
        <div class="user-reward">
          <div class="flex column">
            <div class="item flex-between">
              <!--我的奖励-->
              <p class="inline-block">{{ $t('300079') }}</p>
              <!-- <span class="inline-block bold uppercase">{{
                  isLogin ? fixNumber(awardObj.totalFreeze, 6) : '--'
                }} {{ awardObj.currency }}</span> -->
                <span class="inline-block bold uppercase">{{
                  isLogin ? fixNumber(awardObj.totalFreeze, 6) : '--'
                }} SCS</span>
            </div>
            <!--<div class="item flex-between">
              <!~~冻结数量~~>
              <p class="inline-block">{{ $t('300080') }}</p>
              <span class="inline-block bold uppercase">{{
                  isLogin ? fixNumber(awardObj.awaitUnfreeze, 6) : '--'
                }} {{ awardObj.currency }}</span>
            </div>
            <div class="item flex-between">
              <!~~解锁数量~~>
              <!~~解锁数量=（合约交易手续费+现货交易手续费）/ET 价格~~>
              <p class="inline-block">{{ $t('300081') }} &nbsp;<i class="iconfont icon-tishi" @click="tipsPopup = true"></i>
              </p>
              <span class="inline-block bold uppercase">{{isLogin ? fixNumber(awardObj.unfreeze, 6) : '--' }} {{ awardObj.currency }}</span>
            </div>-->
          </div>
          <div>
            <!--去交易-->
            <van-button class="form-btn" @click="handleTrade">{{ $t('300083') }}</van-button>
          </div>
        </div>
        <div class="rule-clause">
          <div class="rule-content" v-html="ruleContent"></div>
        </div>
      </div>
    </div>
    <van-popup v-model="popupShow" round class="form-popup">
      <div class="form-popup-container">
        <p class="title bold flex-between">{{ $t('300093') }}
          <van-icon name="cross" @click="popupShow = false"/>
        </p>
        <div class="input-box flex column">
          <span class="label block">{{ modelType == 'Twitter' ? $t('300117') : $t('300118') }}</span>
          <div class="input-text flex-center">
            <em class="normal">@</em>
            <input type="text" v-model="temp.account" class="value" id="accountInput"/>
          </div>
          <em class="normal error-msg block" v-show="errorMsg">{{ $t('300092', {type: modelType}) }}</em>
        </div>
        <div class="buttons flex-between">
          <van-button class="cancel-btn" @click="popupShow = false">{{ $t('300119') }}</van-button>
          <van-button class="submit-btn" @click="submitForm()">{{ $t('300104') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="tipsPopup" round class="tip-popup">
      <p class="tip-message">{{ $t('300082') }}</p>
    </van-popup>
  </div>
</template>

<script>
import * as configs from "@/../config/config"
import {getUserInfo} from "../api/user";
import {setCookie, removeCookie, removeToken, getCookie, setToken} from "../utils/auth";
import {Button, Tag, NoticeBar, Icon, Popup, Toast, Empty, Field} from 'vant'
import {receiveRewards, myAward, taskCenterActivity, taskList, taskListLogin, infoUpload} from "../api/resource";
import Methods from '../utils/methods'
import {mapGetters} from 'vuex'
export default {
  name: "task",
  components: {
    vanButton: Button,
    vanTag: Tag,
    vanNoticeBar: NoticeBar,
    vanIcon: Icon,
    vanPopup: Popup,
    vanEmpty: Empty,
    vanField: Field
  },
  data() {
    return {
      isApp: '',
      staticState: configs[configs.Edition].staticState,
      userInfo: {},
      isLogin: false, // 登录状态
      language: '',
      bannerUrl: '',
      taskList: [],
      activeId: 'task',
      /*tabList: [
        {label: '300066', value: 'task'},
        {label: '300071', value: 'rule'}
      ],*/
      ruleContent: '',
      ifSHowMore: false,
      modelShow: false,
      modelType: 'Twitter',
      temp: {
        account: '',
      },
      repeatSubmit: false,
      activityStatus: '',
      jumpLink: '',
      awardObj: {},
      popupShow: false,
      errorMsg: false,
      tipsPopup: false,
      isHidden: '', // 任务是否被下架
      loading: false,
      type: 'login'
    }
  },
  filters: {
    buttonFilter(val, i18ns) {
      let map = {
        3: i18ns.t('300102'), // 去充值
        4: i18ns.t('300083'), // 去交易
        5: i18ns.t('300083'), // 去交易
      }
      return map[val]
    },
    buttonFilter2(val, i18ns) {
      let map = {
        1: i18ns.t('300103'), // 去关注
        2: i18ns.t('300107'), // 加入社群
        3: i18ns.t('300104'), // 去领取
        4: i18ns.t('300104'), // 去领取
        5: i18ns.t('300104'), // 去领取
        6: i18ns.t('300069'), // 去邀请
        9: i18ns.t('300121'), // 去邀请
      }
      return map[val]
    },
  },
  watch: {
    $route() {
      // Toast('监听路由变化')
      this.resher()
      this.getColor()
    }
  },
  computed: {
    ...mapGetters(['isDirection'])
  },
  created() {
    this.resher()
    window.document.documentElement.setAttribute("dir", this.isDirection ? 'rtl' : 'ltr');
  },
  mounted() {
    this.submitApp()
  },
  methods: {
    fixNumber(val, unit) {
      if (val && String(val).indexOf('.') > -1) {
        return Methods.fixNumber(val, unit)
      } else {
        return val
      }
    },
    changeTab(item) {
      if (this.isHidden != 1) return false
      this.activeId = item
      if (item != 'task') {
        document.getElementById(item).scrollIntoView()
      }
    },
    handleTrade() {
      if (!this.isLogin) {
        this.appLogin()
        return false
      } else {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.appSpot, {code: 200}, (data) => {
        })
      }
    },
    handleButton(item) {
      if (!this.isLogin) {
        this.appLogin()
        return false
      } else {
        if (item.type == 3) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.appRecharge, {code: 200}, (data) => {
          })
        } else if (item.type == 4) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.appSpot, {code: 200}, (data) => {
          })
        } else {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.appContract, {code: 200}, (data) => {
          })
        }
      }
    },
    handleClick(item) {
      if (!this.isLogin && item.type == 9) {
        this.type = 'register'
        this.appLogin()
        return false
      } else if (!this.isLogin && item.type != 9) {
        this.type = 'login'
        this.appLogin()
        return false
      } else if (this.activityStatus == '2') {
        Toast(this.$t('300106'))
        return false
      } else {
        if (item.type == 1 && item.completed == 0) {
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1) {
            this.modelType = 'Twitter'
            this.jumpLink = item.url
            this.$jsBridge.callHandler(this.$jsBridgeCmd.openModel, {code: 200, type: 'Twitter'}, (data) => {
            })
          } else {
            this.modelType = 'Twitter'
            this.popupShow = true
            this.temp.account = ''
            this.errorMsg = false
            this.jumpLink = item.url
          }
          return false
        } else if (item.type == 2 && item.completed == 0) {
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1) {
            this.modelType = 'Telegram'
            this.jumpLink = item.url
            this.$jsBridge.callHandler(this.$jsBridgeCmd.openModel, {code: 200, type: 'Telegram'}, (data) => {
            })
          } else {
            this.modelType = 'Telegram'
            this.popupShow = true
            this.temp.account = ''
            this.errorMsg = false
            this.jumpLink = item.url
          }
          return false
        } else if (item.type == 3 || item.type == 4 || item.type == 5) {
          this.receiveRewards(item.type)
        } else if (item.type == 6) {
          this.$jsBridge.callHandler(this.$jsBridgeCmd.goInvite, {code: 200}, (data) => {
          })
        } else {
          return false
        }
      }
    },
    appLogout() {
      var _this = this
      this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogout, {code: 200}, (data) => {
        _this.isLogin = false
        removeToken()
        removeCookie('userInfo')
      })
    },
    appLogin() {
      if (this.isApp == 1) {
        this.$jsBridge.callHandler(this.$jsBridgeCmd.appLogin, {code: 200, type: this.type}, (data) => {
        })
        return false
      }
    },
    submitApp() {
      console.log('????');
      this.$jsBridge.registerHandler(this.$jsBridgeCmd.submitApp, (data) => {
        this.temp.account = data
        this.submitForm()
      })
    },
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.code == 403 || res.code == 413) {
          this.appLogout()
          return false
        }
        if (res.data) {
          this.userInfo = res.data;
          setCookie('userInfo', JSON.stringify(res.data))
        }
      })
    },
    resher() {
      // Toast(this.$route.query.token ? '有token-测试用' : '没有token-测试用')
      this.isApp = this.$route.query.isApp
      var token = this.$route.query.token
      setCookie('language', this.$route.query.language ? this.$route.query.language : 'en')
      this.language = this.$route.query.language ? this.$route.query.language : 'en'
      this.getActivityInfo()
      if (this.isApp == 1) {
        this.$i18n.locale = this.language;
        if (token) {
          setToken(token)
          this.isLogin = true
          this.getUserInfo()
          this.taskListLogin()
          this.getMyAward()
        } else {
          this.taskListFun()
          removeToken()
          this.isLogin = false
        }
      } else {
        this.isLogin = getCookie('token') ? true : false;
        if (this.isLogin) {
          this.getUserInfo()
          this.taskListLogin()
          this.getMyAward()
        } else {
          this.taskListFun()
          removeToken()
        }
      }
    },
    // 获取奖励
    getMyAward() {
      myAward().then(res => {
        if (res.data) {
          this.awardObj = Object.assign({}, res.data)
        }
      })
    },
    // 获取活动信息
    getActivityInfo() {
      this.loading = true
      taskCenterActivity().then(res => {
        this.loading = false
        this.bannerUrl = res.data.bannerUrlH5
        this.ruleContent = res.data.activityRule
        this.activityStatus = res.data.status
        this.isHidden = res.data.onState || ''
      })
    },
    taskListLogin() {
    console.log(
        "122"
    )
      taskListLogin().then(res => {
        // Toast(res.data.length+'res.data')
        this.updateData(res)
      })
    },
    taskListFun() {
      taskList().then(res => {
        this.updateData(res)
      })
    },

    /*// 获取任务列表
    getTaskList() {
      if (this.isLogin) {
        taskListLogin().then(res => {
          Toast(res.data.length+'res.data')
          this.updateData(res)
        })
      } else {
        taskList().then(res => {
          Toast('4')
          this.updateData(res)
        })
      }
    },*/
    // 处理任务列表数据
    updateData(res) {
      if (res.data) {
        res.data.forEach(v => {
          if (v.type == 1) {
            v.title = '300094' // 在Twitter上关注@SuperEx
          } else if (v.type == 2) {
            v.title = '300095' // 加入Telegram官方社區@SuperEx
          } else if (v.type == 3) {
            v.title = '300096' // 完成充值
            v.linkList = {
              'en': 'https://support.superex.com/hc/en-001/articles/4412913782425 ',
              'zh-TC': 'https://support.superex.com/hc/zh-hk/articles/4412811610265',
              'ko': 'https://support.superex.com/hc/ko/articles/4412897688857',
              'ja': 'https://support.superex.com/hc/en-001/articles/4412913782425',
              'ru': 'https://support.superex.com/hc/en-001/articles/4412913782425',
              'fa': 'https://support.superex.com/hc/en-001/articles/4412913782425'
            }
          } else if (v.type == 4) {
            v.title = '300097' // 完成现货交易
            v.linkList = {
              'en': 'https://support.superex.com/hc/en-001/articles/4412913925017',
              'zh-TC': 'https://support.superex.com/hc/zh-hk/articles/4412813558809',
              'ko': 'https://support.superex.com/hc/ko/articles/4412897975065',
              'ja': 'https://support.superex.com/hc/en-001/articles/4412913925017',
              'ru': 'https://support.superex.com/hc/en-001/articles/4412913925017',
              'fa': 'https://support.superex.com/hc/en-001/articles/4412913925017'
            }
          } else if (v.type == 5) {
            v.title = '300098' // 完成合约交易
            v.linkList = {
              'en': 'https://support.superex.com/hc/en-001/articles/4412913942937',
              'zh-TC': 'https://support.superex.com/hc/zh-hk/articles/4412827435033',
              'ko': 'https://support.superex.com/hc/ko/articles/4412898440601',
              'ja': 'https://support.superex.com/hc/en-001/articles/4412913942937',
              'ru': 'https://support.superex.com/hc/en-001/articles/4412913942937',
              'fa': 'https://support.superex.com/hc/en-001/articles/4412913942937'
            }
          } else if (v.type == 6) {
            v.title = '300099' // 推荐朋友注册
            v.linkList = {
              'en': 'https://support.superex.com/hc/en-001/articles/5565386821017',
              'zh-TC': 'https://support.superex.com/hc/zh-hk/articles/5563058103961',
              'ko': 'https://support.superex.com/hc/ko/articles/5565543844761',
              'ja': 'https://support.superex.com/hc/en-001/articles/5565386821017',
              'ru': 'https://support.superex.com/hc/en-001/articles/5565386821017',
              'fa': 'https://support.superex.com/hc/en-001/articles/5565386821017'
            }
          } else if (v.type == 7) {
            v.title = '300100' // 推荐朋友进行交易
          } else if (v.type == 8) {
            v.title = '300101' // 推荐朋友交易更多数额
          } else if (v.type == 9) {
            v.title = '300120' // 立即注册 SuperEx
          }
        })
        this.taskList = res.data || []
      }
    },
    // 领取奖励
    receiveRewards(type) {
        // debugger
      receiveRewards({taskType: type}).then(res => {
        if (res.code != '200') {
            console.log('进不是200的了');
          Toast(res.data.msg)
        } else {
            console.log('进的200');
          Toast(res.msg)
          setTimeout(()=>{
            this.taskListLogin()
            this.getMyAward()
          },500)
        }
      }).catch(() => {
      })
    },
    submitForm(data) {
        console.log('快快快');
      if (this.repeatSubmit) {
        Toast(this.$t('300113'))
        return false
      } else if (!this.temp.account) {
        this.errorMsg = true
        return false
      } else {
        let data = {
          account: this.temp.account,
          type: this.modelType == 'Twitter' ? '1' : '2'
        }
        this.repeatSubmit = true
        infoUpload(data).then(res => {
          if (res.code == '200') {
            this.popupShow = false
            this.repeatSubmit = false
            this.taskListLogin()
            this.getMyAward()
            this.$jsBridge.callHandler(this.$jsBridgeCmd.goBrowser, {code: 200, link: this.jumpLink}, (data) => {
            })
          } else {
            Toast(res.data.msg)
            this.repeatSubmit = false
            this.popupShow = false
          }
        }).catch(() => {
          this.repeatSubmit = false
        })
      }
    },
    inputFocus() {

    }
  }
}
</script>
<style lang="scss">
@import "../assets/css/variableName";
@import "../style/mixin";

.rule-content p {
  font-size: torem(14);
  color: #7F8490;
  line-height: 2;
}
</style>
<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

.inline-block {
  display: inline-block;
}

.focusState {
  position: absolute;
}

.task-center {
  background-color: #24252A;

  .no-task {
    height: 100vh;
    text-align: center;
    justify-content: center;

    /deep/ .van-empty__image {
      svg {
        padding-top: torem(20);
        width: torem(80);
        height: torem(80);
      }
    }

    /deep/ .van-empty__description {
      font-size: torem(12);
      color: #40475A;
    }

    p {
      font-size: torem(14);
      color: #000922;
    }
  }

  &-banner {
    height: torem(200);
    width: 100%;
    padding: 0 torem(28) torem(37.5);
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    h1 {
      @include sc(torem(24), #fff);
      //font-family: pingfangsc-medium;
      line-height: 1.5;
    }

    p {
      //font-family: pingfangsc-regular;
      @include sc(torem(12), #fff);
      line-height: 1.5;
      max-width: torem(235);
    }

    /deep/ .van-button {
      border-radius: torem(2);
      padding: torem(1) torem(12);
      height: auto;
      margin-top: torem(6);
    }

    /deep/ .van-button__text {
      @include sc(torem(14), #000922);
      //font-family: pingfangsc-regular;
    }

    a.inline-block {
      width: max-content;
      margin-top: torem(10);
      font-size: torem(14);
      color: #FFC72B;
      background-color: #333;
      border: torem(0.55) solid #FFC72B;
      border-radius: torem(4);
      padding: torem(5);
      i.iconfont{
        margin-right: torem(3);
        vertical-align: torem(-1);
      }
    }
    a.ltr{
      margin-right: torem(24);
    }
    a.rtl{
      margin-left: torem(24);
      i{
        display: inline-block;
        direction: rtl;
      }
    }
  }

  .task-container {
    background-color: #fff;
    padding: torem(28) torem(16);
    border-radius: torem(16) torem(16) 0 0;

    ul.tabs {
      li.tab-item {
        @include sc(torem(14), #7F8490);
        padding: torem(4) torem(12);
        line-height: 1.2;
      }

      li.active {
        background-color: #FFC72B;
        color: #000922 !important;
        border-radius: torem(2);
      }
    }


    #task, #rule {
      .title {
        margin-bottom: torem(24);

        svg.icon {
          width: torem(21);
          height: torem(21);
        }

        h1 {
          margin: 0 torem(8);
          font-size: torem(16);
          color: #000922;
        }

        span {
          margin-top: torem(9);
          font-size: torem(12);
          color: #7F8490;
        }
      }

      .tip-message {
        font-size: torem(12);
        color: #7F8490;
        margin: torem(8) 0;
        line-height: 1.5;
      }
    }

    #task {
      margin-top: torem(41);

      .task-list {
        min-height: torem(400);

        &-item {
          padding: torem(24) torem(16);
          margin-bottom: torem(12);
          box-shadow: 0 torem(6) torem(8) torem(1) rgba(0, 61, 118, 0.06);
          border-radius: torem(8);
          border: torem(0.55) solid #EFEFEF;
          background-color: #fff;
          align-items: flex-start;

          .left-content {
            max-width: torem(182);

            p.bold {
              font-size: torem(14);
              color: #000922;
              margin-bottom: torem(16);
              line-height: 1.2;
            }

            div.flex-center {
              svg {
                width: torem(16);
                height: torem(16);
              }

              span {
                font-size: torem(14);
                color: #FFC72B;
                margin: 0 10px;
              }

              a i.iconfont {
                color: #999999;
                font-size: torem(14);
              }
            }
          }
          .left-content-ltr{
            margin-right: torem(12);
          }
          .left-content-rtl{
            margin-left: torem(12);
          }

          .right-button {
            width: max-content;
            align-items: flex-end;

            .first-btn {
              padding: 0;
              margin-bottom: torem(16);
              line-height: 1.2;
              min-width: torem(75);
              background: transparent;
              font-size: torem(12);
              color: #FFC72B;
              border: none;
              border-radius: torem(4);
              height: auto;
              white-space: nowrap;
              font-weight: 600;

              /deep/ .van-icon {
                vertical-align: torem(-1.5);
                font-size: torem(14);
              }
            }

            /deep/ .van-button--disabled {
              opacity: 1;
            }

            .completed-btn {
              padding: 0 torem(4);
              min-width: torem(75);
              width: auto;
              height: torem(33);
              line-height: torem(33);
              border: none;
              color: #7F8490;
              background-color: #EDEFF1;
              font-size: torem(12);
              cursor: not-allowed;
              border-radius: torem(4);
              font-weight: 600;
            }

            .form-btn {
              padding: 0 torem(4);
              min-width: torem(75);
              max-width: torem(106);
              width: auto;
              height: torem(33);
              line-height: torem(33);
              background-color: #FFC72B;
              font-size: torem(12);
              color: #000922;
              border: none;
              border-radius: torem(4);
              font-weight: 600;
            }

            p.column {
              align-items: center;

              span:first-child {
                margin-bottom: torem(16);
                color: #7F8490;
                font-size: torem(12);
                line-height: 1.2;
                white-space: nowrap;
              }

              span.bold {
                color: #000922;
                font-size: torem(16);
              }
            }
          }
        }
      }

      .completed {
        width: 100%;
        text-align: center;
        height: torem(33);
        line-height: torem(33);
        line-height: 1;
        /*padding: torem(12) 0;*/
        border: torem(0.55) solid #FFC72B;
        background-color: rgba(255, 199, 43, 0.1);
        color: #000922;
        font-size: torem(12);
        border-radius: torem(4);
        font-weight: 600;
      }
    }

    #rule {
      padding-top: torem(44);

      .user-reward {
        padding: torem(16);
        box-shadow: 0 torem(6) torem(8) torem(1) rgba(0, 61, 118, 0.06);
        border-radius: torem(4);
        border: torem(0.55) solid #EFEFEF;
        background-color: #fff;
        margin-bottom: torem(28);
        flex-wrap: wrap;

        .item {
          margin-bottom: torem(22);

          p {
            font-size: torem(12);
            color: #7F8490;

            i {
              font-size: torem(12);
            }
          }

          span.inline-block {
            font-size: torem(16);
            color: #000922;
            line-height: 1.2;
          }
        }

        .form-btn {
          width: 100%;
          padding: torem(10) torem(8);
          background-color: #FFC72B;
          color: #000922;
          font-size: torem(14);
          border: none;
          height: auto;
          border-radius: torem(4);
        }
      }

      .rule-clause {
        p.bold {
          font-size: torem(14);
          color: #000922;
          margin-bottom: torem(8);
        }
      }
    }
  }
}

.form-popup {
  .form-popup-container {
    padding: torem(24);
    background: #fff;
    width: torem(320);
    height: auto;

    p.title {
      padding: torem(8) 0;
      font-size: torem(16);
      color: #000922;
      margin-bottom: torem(16);

      /deep/ .van-icon-cross {
        font-size: torem(16);
        color: #666666;
      }
    }

    .input-box {
      .label {
        font-size: torem(14);
        color: #000922;
        margin-bottom: torem(8);
        line-height: 1.2;
      }

      .input-text {
        em {
          font-size: torem(16);
          color: #000922;
          margin-right: torem(6);
        }

        input.value {
          width: 100%;
        }

      }

      .value {
        padding: torem(13) torem(12);
        border-radius: torem(2);
        border: torem(0.55) solid #DCDFE6;
        font-size: torem(14);
        margin-bottom: torem(8);
      }

      .error-msg {
        font-size: torem(12);
        color: #F56C6C;
      }
    }

    .buttons {
      margin-top: torem(24);

      .cancel-btn, .submit-btn {
        width: 48%;
        height: auto;
        padding: torem(13) 0;
        border-radius: torem(4);
        font-size: torem(15);
        color: #000922;
        border: none;
      }

      .cancel-btn {
        background-color: #EAECEF;
      }

      .submit-btn {
        background-color: #FFC72B;
      }
    }
  }
}

.tip-popup {
  .tip-message {
    width: torem(320);
    padding: torem(24);
    height: auto;
    line-height: 1.5;
    font-size: torem(14);
    color: #000922;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/task.vue